<template>
  <div id="app">
    <header_index v-if="$route.meta.navShow"></header_index>
    <router-view v-if="isRouterAlive"></router-view>
    <footer_index v-if="$route.meta.navShow"></footer_index>
  </div>
</template>

<script>
import header_index from './views/home/header_index';
import footer_index from './views/home/footer_index';
import * as sysTool from './assets/unit/GetuserAgent';
export default {
  name: 'App',
  // 提供一个刷新的依赖
  provide () {
    return {
      reload: this.reload
    };
  },
  data () {
    return {
      isRouterAlive: true
    };
  },
  components: {
    header_index,
    footer_index
  },
  created () {
    var userAgent = navigator.userAgent;
    var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1;
    var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
    var compatibilityMode = window.navigator.userAgent.indexOf('compatible') != -1;
    if (isIE || isIE11 || compatibilityMode) {
      document.body.innerHTML = "<div> <div style='width:900px;margin:0 auto;font-family:Microsoft YaHei'> <p style='padding-top:100px;margin:0;text-align:center;margin-bottom:40px;color:#999;font-size:30px;'>抱歉！您浏览的页面无法正常显示</p> <p style='color:#999;font-size:20px;margin-left:50px;'>推荐使用Chrome，Firefox，Edge浏览器，如果您使用的是360、搜狗、QQ等双核浏览器，<br>请切换到极速模式访问(如下图所示)</p> <div style='text-align:center;margin-top:50px'> <img style='width:700px'  src='/image/index/iepage.png' /></div></div></div>"
    }
    this.GetWebdiscount()
  },
  mounted () {
    // 禁用右键
    document.oncontextmenu = function () {
      return false;
    };
    // document.onkeydown = function() {
    //     var e = window.event || arguments[0];
    //     if (e.keyCode == 123) {
    //         // f12
    //         return false;
    //     } else if (e.ctrlKey && e.shiftKey && e.keyCode == 73) {
    //         // ctrl+shift+i
    //         return false;
    //     } else if (e.ctrlKey && e.keyCode == 85) {
    //         // ctrl+u查看源代码
    //         return false;
    //     } else if (e.ctrlKey && e.keyCode == 83) {
    //         // ctrl+s另存为
    //         return false;
    //     }
    // };
  },
  methods: {
    reload () {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },

    /** 获取是否开启六折 */
    GetWebdiscount () {
      this.httphelper.get('api/CGPInfoApi/GetWebdiscount').then(res => {
        if (res.code == 200) {
          const startDateStr = res.data.startDate;
          const endDateStr = res.data.endDate;
          const isBetweenDates = this.isCurrentTimeBetweenDates(startDateStr, endDateStr);

          if (isBetweenDates) {
            console.log('当前时间在指定日期范围内');
            localStorage.setItem('isSix', true)
          } else {
            console.log('当前时间不在指定日期范围内');
            localStorage.setItem('isSix', false)
          }
        }
      })
    },

    /** 判断是否在六折期间 */
    isCurrentTimeBetweenDates (startDateStr, endDateStr) {
      // 将字符串转换为Date对象  
      const now = new Date();
      const startDate = new Date(startDateStr);
      const endDate = new Date(endDateStr);

      // 确保startDate在endDate之前  
      if (startDate > endDate) {
        const temp = startDate;
        startDate = endDate;
        endDate = temp;
      }

      // 判断当前时间是否在日期范围内  
      return now >= startDate && now <= endDate;
    },
  },
  watch: {
    '$route': {
      handler (to, from) {
        if (!(window.location.host.indexOf('localhost') > -1)) {
          this.httphelper.post('/api/CGpUserApi/SaveUserBehavior', {
            userID: localStorage.getItem('ResData') == null ? 0 : JSON.parse(localStorage.getItem('ResData')).id,
            ip: localStorage.getItem('Ip') == null ? '未获取' : localStorage.getItem('Ip'),
            area: localStorage.getItem('cityname') == null ? '未获取' : localStorage.getItem('cityname'),
            weburl: window.location.origin + to.fullPath,
            os: sysTool.getOS(),
            browser: sysTool.getBrowser(),
            network: sysTool.getNetworkType()
          });
        }
      },
      immediate: true
    }

  }
};
</script>

<style>
@import 'assets/css/comm.css';
@import 'assets/css/globe.css';
@import 'assets/css/swiperSet.css';

#app {
    height: 100%;
}

.imgBanner {
    width: 100%;
    cursor: pointer;
}

.imgtran {
    transform: scale(1.03);
    cursor: pointer;
}

.el-popconfirm .el-button--text {
    color: #0b8586;
}

.el-popconfirm .el-button--text:hover {
    color: #0b8586;
}

.el-popconfirm .el-button--primary {
    background-color: #0b8586;
    border-color: #0b8586;
}

.el-popconfirm .el-button--primary:hover {
    background-color: #0b8586;
    border-color: #0b8586;
}

.xl-chrome-ext-bar {
    display: none;
}
</style>
